if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

// call anytime the basket changes in any way
// this debounces calls the refreshes the DOM to match whatever is current
function BasketChanged() {
    if (window._basketChangedDebouncTimer != undefined) {
        clearTimeout(window._basketChangedDebouncTimer);
    }
    window._basketChangedDebouncTimer = setTimeout(refreshCart, 100);
}

function GetPostDataFromProperties(obj, properties) {
    properties.forEach(property => {
        obj[property[0]] = property[1];
    });
    return obj;
}

function getCurrentCart(cb)//Gets the current cart
{
    $.getJSON("/cart.json", function (response) {
        cb(response)
    });
}

function updateItem(key, properties, cb) {
    //updates a given cart line_item using properties passed to it in the format [["property1","value1"],["property2","value2"]]
    var update = { 'id': parseInt(key) };
    update = GetPostDataFromProperties(update, properties);

    $.post("/cart/change.js", update, function (response) {
      Shopify.getCart(function(cart) {
        cb(response);
      }.bind(this));  
    }, "json");
}

function HandleQtyButtonClick(elem) {
    //functionality for adding 1 to quantity
    var item = elem.closest(".dm-cart-item");
    var qty = Number(item.querySelector(".side-cart-quantity-amt").getAttribute("data-amt"));
    var id = item.getAttribute("data-line_item-id");

    if (elem.classList.contains("quantity-plus")) {
        qty = [["quantity", qty + 1]];
    }
    else {
        qty = [["quantity", qty - 1]];
    }

    updateItem(id, qty, function (result) {
        BasketChanged();
    });
}

function penceToPound(pence) {
    const dmSideCart = document.querySelector('.dm-side-cart');
    const currencyFormat = dmSideCart.dataset.currencyFormat;
    
    const output = window.Shopify.formatMoney( pence, currencyFormat );
    console.log('PENCE TO POUND NEW: ', output);
    return output;
    
    /*
    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    });

    return formatter.format(pence / 100)
    */
}

function refreshCart() {
    getCurrentCart(function (cart) {
        var itemlist = document.querySelector(".dm-cart-item-list");
        itemlist.innerHTML = "";
        var template = document.querySelector(".dm-cart-item-template");

        if (cart.item_count == 0) {
            BuildCartWithNoItems(cart);
        }
        else {
            BuildCartWithItems(itemlist, template, cart);
        }

        UpdateSubTotal(cart);
        HandleCartCount(cart);
        HandleCartFreeShippingMessage(cart);
        HandleProductFreeShippingMessage(cart);
    });
}

function BuildCartWithItems(parent, target, cart) {
    function HandleCartItems(idx) {
        if (idx < cart.items.length) {
            var cartItem = cart.items[idx];
            GetShopifyItem(cartItem.url + ".js", "GET", function (product) {
                product = product.product;
                var item = BuildCartItem(target, cartItem, product);
                parent.appendChild(item);

                HandleCartItems(idx + 1);
            });
        }
        else {
            //Add event listeners
            $(".side-cart-quantity-button").click(function (e) {
                e.preventDefault();
                HandleQtyButtonClick(e.currentTarget);
            });
        }
    }
    HandleCartItems(0);
}

function BuildCartWithNoItems(cart) {
    var cartBody = document.querySelector(".side-cart-body");
    var cartItemList = cartBody.querySelector(".dm-cart-item-list");

    if (cartItemList) {
        var emptyCartElTarget = document.querySelector(".dm-cart-no-items-container-target");
        if (emptyCartElTarget) {
            emptyCartElTarget.classList.remove("hidden");
            emptyCartElTarget.classList.remove("dm-cart-no-items-container-target");

            cartItemList.appendChild(emptyCartElTarget);
        }
    }
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function BuildCartItem(target, item, product) {
    var copy = target.cloneNode(true);
    var variant = GetVariantFromLineItem(item, product);
    copy.setAttribute("data-line_item-id", item.variant_id);

    //image
    var image = copy.querySelector(".side-cart-img");
    image.setAttribute("src", item.featured_image.url);

    //title
    var titleEl = copy.querySelector(".dm-side-cart-item-title");
    titleEl.innerText = capitalizeFirstLetter(item.product_title);

    //to do: add compare at price
    var priceEl = copy.querySelector(".dm-side-cart-item-price");
    priceEl.innerHTML = GetItemPriceMarkup(item, variant);

    var optionWithValuesEl = copy.querySelector(".dm-side-cart-options-container");
    for (var i = 0; i < item.options_with_values.length; i++) {
        var p = document.createElement("p");
        p.setAttribute("class", "dm-side-cart-item-size");
        p.innerText = capitalizeFirstLetter(item.options_with_values[i].name.toLowerCase()) + ": " + capitalizeFirstLetter(item.options_with_values[i].value.toLowerCase());
        optionWithValuesEl.appendChild(p);

        if (i !== item.options_with_values.length - 1) {
            var p = document.createElement("p");
            p.setAttribute("class", "dm-side-cart-item-size");
            p.innerText = '|'
            optionWithValuesEl.appendChild(p);
        }
    }

    //qty
    var qtyEl = copy.querySelector(".side-cart-quantity-amt");
    qtyEl.setAttribute("data-amt", item.quantity);
    qtyEl.innerText = item.quantity;

    let links = copy.querySelectorAll("[data-side-cart-item-link]");

    for (let link of links) {
        link.setAttribute('href', item.url)
    }

    //remove classes
    copy.classList.remove("hidden");
    copy.classList.remove("dm-cart-item-template");

    return copy;
}

function GetVariantFromLineItem(item, product) {
    if (product.variants && product.variants.length) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variant.id == item.variant_id) {
                return variant;
            }
        }
    }
}

function GetItemPriceMarkup(item, variant) {
    if (variant) {
        if (variant.compare_at_price) {
            var compareAtPrice = Number(variant.compare_at_price * 100);
            if (compareAtPrice > item.price) {
                return "<span class='side-cart-compare'>" + penceToPound(compareAtPrice) + "</span> " + penceToPound(item.price);
            }
            else {
                return penceToPound(item.price);
            }
        }
        else {
            return penceToPound(item.price);
        }
    }
    else {
        return penceToPound(item.price);
    }
}

function HandleCartCount(cart) {
    var counts = document.querySelectorAll(".cart-count");
    for (var x = 0; x < counts.length; x++) {
        counts[x].innerText = cart.item_count;
    }
}

function UpdateSubTotal(cart) {
    var priceEl = document.querySelector(".side-cart-sub-total-inner strong");
    priceEl.innerText = penceToPound(cart.total_price);
}

function HandleProductFreeShippingMessage(cart) {
    var freeShippingEl = document.querySelector(".product-free-shipping");
    if (!freeShippingEl) return;
    var freeShippingThreshold = Number(freeShippingEl.getAttribute("data-free-shipping-amount"));
    var curentProductPrice = Number(freeShippingEl.getAttribute("data-product-price"));
    var cartInclProductTotal = Number(cart.total_price + curentProductPrice);

    var freeShippingText = freeShippingEl.querySelector(".free-shipping-text");

    if (cartInclProductTotal >= freeShippingThreshold && cart.total_price < freeShippingThreshold) {
        freeShippingText.innerHTML = freeShippingText.getAttribute("data-free-shipping-progress-text");
        freeShippingEl.classList.remove('hide');
    } else if (cartInclProductTotal >= freeShippingThreshold && cart.total_price >= freeShippingThreshold) {
        freeShippingText.innerHTML = freeShippingText.getAttribute("data-free-shipping-qualify-text");
        freeShippingEl.classList.remove('hide');
    } else {
        freeShippingEl.classList.add('hide');
    }
}

function HandleCartFreeShippingMessage(cart) {
    var freeShippingText = document.querySelector(".quick-cart-free-shipping-amount");
    var freeShippingThreshold = Number(freeShippingText.getAttribute("data-free-shipping-amount"));
    var freeShippingIndicator = document.querySelector("[data-free-shipping-indicator]");

    if (cart.total_price > freeShippingThreshold) {
        freeShippingText.innerHTML = freeShippingText.getAttribute("data-free-shipping-qualify-text");
        freeShippingIndicator.classList.add('hide');
    }
    else {
        var amountLeft = freeShippingThreshold - cart.total_price;
        var message = freeShippingText.getAttribute("data-free-shipping-text");
        var freeShippingPercentage = cart.total_price * 100 / freeShippingThreshold;
        message = message.replace('[amount]', penceToPound(amountLeft));
        freeShippingText.innerHTML = message;
        freeShippingIndicator.classList.remove('hide');
        freeShippingIndicator.style.setProperty('--freeShippingPercentage', freeShippingPercentage + '%');
    }
}

function HandleCartUpsell(element) {
    var parent = SearchParentsFor(element, "dm-cart-item");
    var select = parent.querySelector(".product-options");
    var id;

    for (var i = 0; i < select.options.length; i++) {
        var option = select.options[i];
        if (option.getAttribute("selected")) {
            id = option.value;
        }
    }

    if (!id) {
        var option = select.querySelector("option[ data-option-target='true' ]:not( [ disabled='disabled' ] )");
        id = option.value;
    }

    var post = { "id": id, "quantity": 1 };
    DoAddToCart(post, function (response) {
        BasketChanged();
    });
}

function HandleCartQuickAddChange(select) {
    var option = select.options[select.selectedIndex];
    option.setAttribute("selected", "selected");
}

document.addEventListener('click', function (e) {
    if (e.target.matches('.side-cart-quantity-button')) {
        e.preventDefault();
        HandleQtyButtonClick(e.target);
    }
    if (e.target.matches('.cart-drawer-toggle')) {
        e.preventDefault();
        HandleSideCart(e);
    }
    if (e.target.matches('.side-cart-remove-button')) {
        e.preventDefault();
        var elem = e.target;
        var item = elem.closest(".dm-cart-item");
        var id = item.getAttribute("data-line_item-id");

        updateItem(id, [["quantity", 0]], function (result) {
            BasketChanged();
        });
    }
    if (e.target.matches('.dm-cart-col-quick-add-button')) {
        e.preventDefault();
        HandleCartUpsell(e.target);
    }
    if (e.target.matches('.dm-cart-col-quick-add-variant select')) {
        e.preventDefault();
        HandleCartQuickAddChange(e.target);
    }
});